module.exports = "<button class=\"session-image-button\" data-bind-target=\"session-image-button\"><img class=\".session-image\" src=\"xxxHTMLLINKxxx0.5752463914332460.30776836223138115xxx\" alt=\"\" draggable=\"false\"/></button>\n";


//////////////////
// WEBPACK FOOTER
// ./app/views/partials/sessions/session-image-button.html
// module id = 640
// module chunks = 1